import { gql } from '@apollo/client';

export const updateCampaignItems = gql`
    mutation updateCampaignItems($updateCampaignId: ID!, $input: UpdateCampaignInput!) {
        updateCampaign(id: $updateCampaignId, input: $input) {
            id
        }
    }
`;
